import type { Mission } from '../missions.ts'

export const dea: Mission = {
  id: "dea",
  name: "Drug Enforcement Administration",
  short: "DEA",
  call: "Drug Enforcement",
  kind: "subagency",
  parent: "doj",
  url: "https://www.dea.gov/",
  established: 1973,
  palette: {
    primary: "#900028",
    secondary: "#0099d8",
    accent: "#2fb457",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:US-DrugEnforcementAdministration-Seal.svg",
  },
  motif: "eagle",
  mission: {
    text: "The mission of the Drug Enforcement Administration (DEA) is to enforce the controlled substances laws and regulations of the United States and bring to the criminal and civil justice system of the United States, or any other competent jurisdiction, those organizations and principal members of organizations, involved in the growing, manufacture, or distribution of controlled substances appearing in or destined for illicit traffic in the United States; and to recommend and support non-enforcement programs aimed at reducing the availability of illicit controlled substances on the domestic and international markets.",
    url: "https://www.dea.gov/about/mission",
  },
  fact: {
    text: "DEA has 81 foreign offices in 61 countries.",
    url: "https://www.dea.gov/foreign-offices",
  },
  seal: {
    file: "public/seals/dea.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-DrugEnforcementAdministration-Seal.svg",
  },
  identifier: {
    about: "https://www.dea.gov/who-we-are/about",
    accessibility: "https://www.dea.gov/resources/accessibility-and-policy",
    foia: "https://www.dea.gov/foia",
    noFear: "https://www.justice.gov/jmd/eeo-program-status-report",
    oig: "https://oig.justice.gov/",
    performance: "https://www.justice.gov/doj/budget-and-performance",
    privacy: "https://www.justice.gov/doj/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/dea-tradewinds-training.jpg",
        small: "/media/dea-tradewinds-training-sm.jpg",
        alt: "A DEA special agent in a tactical vest and an instructor coach Caribbean security officers beside an SUV during a detention techniques exercise on a grassy training field.",
        title: "DEA special agents instruct at TRADEWINDS 24, Regional Police Training Centre, Christ Church, Barbados, May 6, 2024",
        creator: "Sgt. Joshua Taeckens, U.S. Army",
        source: "https://commons.wikimedia.org/wiki/File:DEA_Special_Agents_instruct_detainee_techniques_at_TRADEWINDS_24_(8399477).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/dea-museum.jpg",
        small: "/media/dea-museum-sm.jpg",
        alt: "A red DEA Museum sign stands in a planted plaza in front of the glass office tower that houses the museum.",
        title: "Drug Enforcement Administration Museum and Visitors Center entrance, Arlington, Virginia, April 20, 2019",
        creator: "Thomson200",
        source: "https://commons.wikimedia.org/wiki/File:Drug_Enforcement_Administration_Museum_and_Visitors_Center_front_entrance,_April_2019.jpg",
        license: "CC0 1.0 (public domain dedication)",
      },
    ],
  },
}
